import {
  GraphConfig,
  GraphType,
} from "@intelligems/ig-types/schemas/analytics/custom-graphs";

export const rolloutGraphConfig: GraphConfig[] = [
  {
    title: ["Conversion Rate"],
    metrics: ["conversion_rate"],
    canBeKeyMetric: true,
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    hasAudience: true,
    hasImpactCalculation: true,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    isImpactGraph: true,
  },
  {
    title: ["Revenue per Visitor"],
    metrics: [
      "net_revenue_per_visitor",
      "net_revenue",
      "n_orders",
      "n_visitors",
    ],
    canBeKeyMetric: true,
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    hasAudience: true,
    hasImpactCalculation: true,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    isImpactGraph: true,
  },
  {
    title: ["Profit per Visitor"],
    metrics: ["gross_profit_per_visitor", "net_revenue"],
    canBeKeyMetric: true,
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    hasAudience: true,
    hasImpactCalculation: true,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    isImpactGraph: true,
  },
  {
    title: ["Average Order Value"],
    metrics: ["net_revenue_per_order"],
    canBeKeyMetric: true,
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.StackedBar,
    hasAudience: true,
    hasImpactCalculation: false,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    isImpactGraph: true,
  },
];

export const newOverviewGraphConfig: GraphConfig[] = [];

export const newProfitGraphConfig: GraphConfig[] = [
  {
    title: ["Profit per Visitor"],
    metrics: ["gross_profit_per_visitor"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,
    hasValueCI: true,
    hasProbability: true,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: true,
  },
  {
    title: ["Product Revenue"],
    metrics: ["net_product_revenue"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Total COGS"],
    metrics: ["total_cogs"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Product Profit"],
    metrics: ["product_profit"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,
    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Shipping Revenue"],
    metrics: ["net_shipping_revenue"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Shipping Cost"],
    metrics: ["total_shipping_cost"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Shipping Profit"],
    metrics: ["shipping_profit"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Transaction Fees"],
    metrics: ["total_transaction_fee"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Total Tax Included"],
    metrics: ["total_tax_included"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Net Revenue"],
    metrics: ["net_revenue"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Total Cost"],
    metrics: ["total_cost"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Total Profit"],
    metrics: ["gross_profit"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["% Gross Margin"],
    metrics: ["gross_margin_pct"],
    datasetId: "variation_overview",
    dataTypes: ["percentTwoDecimal"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Visitors"],
    metrics: ["n_visitors"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: false,
    canBeKeyMetric: false,
  },
  {
    title: ["Orders"],
    metrics: ["n_orders"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: false,
    canBeKeyMetric: false,
  },
  {
    title: ["Profit per Order"],
    metrics: ["gross_profit_per_order"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: true,
    hasProbability: true,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
];

export const newCustomMetricsGraphConfig: GraphConfig[] = [];

// The order_reconciliation endpoint projects no metrics — it returns
// exclusion_reason / n_orders / example_orders, which is all
// OrdersReconciliationTable reads. The requested metrics only flip the shared
// session-order gates upstream, so anything beyond one order metric is pure
// query cost: session-events metrics (add_to_cart_rate, checkout_begin_rate)
// set has_events_metrics, which joins the expensive session_events aggregation,
// and profit metrics set requires_cogs, which joins order_cogs. Keep this to a
// single order metric (the payload is rejected if metrics is empty). Behavior
// filters still re-add the session-events join on their own, since the
// reconciliation reasons report them.
export const newDataReconciliationGraphConfig: GraphConfig[] = [
  {
    title: [""],
    metrics: ["n_orders"],
    dataTypes: ["currency"],
    datasetId: "order_reconciliation",
    graphType: GraphType.Bar,
    isImpactGraph: true,

    canBeKeyMetric: true,
    hasProbability: false,
    hasTimeseries: true,
    hasValueCI: false,
    hasAudience: true,
    hasImpactCalculation: false,
  },
];

export const newShippingGraphConfig: GraphConfig[] = [
  {
    title: ["Shipping Revenue per Order"],
    metrics: [
      "net_shipping_revenue_per_order",
      "n_visitors",
      "n_orders",
      "net_revenue",
    ],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    isImpactGraph: true,

    canBeKeyMetric: true,
    hasProbability: false,
    hasTimeseries: true,
    hasValueCI: false,
    hasAudience: true,
    hasImpactCalculation: false,
  },
  {
    title: ["% of Orders with Free Shipping"],
    metrics: ["pct_orders_free_shipping"],
    dataTypes: ["percent"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    isImpactGraph: true,

    canBeKeyMetric: false,
    hasProbability: false,
    hasTimeseries: true,
    hasValueCI: false,
    hasAudience: true,
    hasImpactCalculation: false,
  },
  {
    title: ["Order Value Distribution"],
    metrics: ["n_orders_free_shipping"],
    dataTypes: ["currency"],
    datasetId: "variation_shipping_method",
    graphType: GraphType.Line,

    canBeKeyMetric: false,
    hasProbability: false,
    hasTimeseries: false,
    hasValueCI: false,
    hasAudience: false,
  },
  {
    title: ["Cumulative % of Orders"],
    metrics: [
      "n_orders_free_shipping",
      "pct_orders_free_shipping",
      "net_shipping_revenue_per_order",
      "total_shipping_cost",
      "shipping_profit",
      "n_visitors",
      "n_orders",
    ],
    dataTypes: ["currency"],
    datasetId: "variation_shipping_method",
    graphType: GraphType.Line,

    canBeKeyMetric: false,
    hasProbability: false,
    hasTimeseries: false,
    hasValueCI: false,
    hasAudience: false,
  },

  {
    title: [""],
    metrics: ["n_orders"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_shipping_method",
    filterMetric: "shipping_method",
    graphType: GraphType.Bar,

    canBeKeyMetric: false,
    hasProbability: false,
    hasTimeseries: false,
    hasValueCI: false,
    hasAudience: false,
  },
  {
    title: [""],
    metrics: ["net_shipping_revenue_per_order"],
    dataTypes: ["currency"],
    filterMetric: "shipping_method",
    datasetId: "variation_shipping_method",
    graphType: GraphType.Bar,

    canBeKeyMetric: false,
    hasProbability: false,
    hasTimeseries: false,
    hasValueCI: false,
    hasAudience: false,
  },
  {
    title: ["Net Shipping Revenue"],
    metrics: ["net_shipping_revenue"],
    dataTypes: ["currency"],
    isImpactGraph: true,
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },
];

export const newConversionGraphConfig: GraphConfig[] = [
  {
    title: ["View Collection Rate"],
    isImpactGraph: true,
    metrics: ["view_collection_page_rate"],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    canBeKeyMetric: true,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },
  {
    title: ["View Product Rate"],
    isImpactGraph: true,
    metrics: ["view_product_page_rate"],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    canBeKeyMetric: true,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },
  {
    title: ["ATC Rate"],
    isImpactGraph: true,
    metrics: ["add_to_cart_rate"],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    canBeKeyMetric: true,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },
  {
    title: ["Abandoned Cart Rate"],
    isImpactGraph: true,
    metrics: ["abandoned_cart_rate"],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    canBeKeyMetric: true,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
    impactCalculationColoring: "inverted",
  },
  {
    title: ["Begin Checkout Rate"],
    isImpactGraph: true,
    metrics: ["checkout_begin_rate"],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    canBeKeyMetric: true,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },
  {
    title: ["Abandoned Checkout Rate"],
    isImpactGraph: true,
    metrics: ["abandoned_checkout_rate"],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    canBeKeyMetric: true,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
    impactCalculationColoring: "inverted",
  },
  {
    title: ["Conversion Rate"],
    isImpactGraph: true,
    metrics: ["conversion_rate"],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    canBeKeyMetric: true,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },

  {
    filterMetric: "dt",

    title: [""],
    metrics: [
      "conversion_rate",
      "add_to_cart_rate",
      "checkout_begin_rate",
      "checkout_enter_contact_info_rate",
      "checkout_address_submitted_rate",
      "view_product_page_rate",
      "view_collection_page_rate",
      "n_visitors",
      "n_visitors_ordered",
      "gross_profit_per_visitor",
      "net_revenue_per_visitor",
      "abandoned_cart_rate",
      "n_visitors_abandoned_cart",
      "abandoned_checkout_rate",
      "n_visitors_abandoned_checkout",
    ],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Sankey,
    canBeKeyMetric: false,
    hasProbability: false,
    hasTimeseries: false,
    hasValueCI: false,
    hasAudience: false,
  },
  {
    title: [],
    isImpactGraph: true,
    metrics: [
      "n_visitors_added_to_cart",
      "n_visitors_checkout_started",
      "n_visitors_abandoned_cart",
      "n_visitors_abandoned_checkout",
      "n_visitors_checkout_contact_info_submitted",
      "n_visitors_checkout_address_info_submitted",
      "n_visitors_viewed_product_page",
      "n_visitors_viewed_collection_page",
    ],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    canBeKeyMetric: false,
    hasProbability: false,
    hasTimeseries: false,
    hasValueCI: false,
    hasAudience: false,
    hasImpactCalculation: false,
  },
];

export const newRevenueGraphConfig: GraphConfig[] = [
  {
    title: ["Revenue per Visitor"],
    metrics: ["net_revenue_per_visitor"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    isImpactGraph: true,
    graphType: GraphType.Bar,

    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },
  {
    title: ["AOV (Net Revenue per Order)"],
    metrics: [
      "net_product_revenue_per_order",
      "net_shipping_revenue_per_order",
    ],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.StackedBar,
    isImpactGraph: true,
    stackedBarLegendTitles: ["Product AOV", "Shipping AOV"],

    showSumStackedLabels: true,
    hasTimeseries: false,
    canBeKeyMetric: true,
    hasProbability: false,
    hasAudience: false,
    hasValueCI: false,
    impactMetric: "net_revenue_per_order",
    hasImpactCalculation: false,
  },
  {
    title: ["Net Product Revenue per Order"],
    metrics: ["net_product_revenue_per_order"],
    dataTypes: ["currency"],
    isImpactGraph: true,
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
  },
  {
    title: ["Net Shipping Revenue per Order"],
    metrics: ["net_shipping_revenue_per_order"],
    dataTypes: ["currency"],
    isImpactGraph: true,
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
  },
  {
    title: ["Avg Units per Order"],
    metrics: ["avg_units_per_order"],
    dataTypes: ["number"],
    isImpactGraph: true,
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
  },
  {
    title: ["Avg Product Revenue per Unit"],
    metrics: ["avg_product_revenue_per_unit"],
    dataTypes: ["currency"],
    isImpactGraph: true,
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
  },
  {
    title: ["Total Avg Order Value"],
    metrics: ["net_revenue_per_order"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    isImpactGraph: false,

    showSumStackedLabels: false,
    canBeKeyMetric: false,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    hasAudience: true,
  },
  {
    title: ["Net Shipping Revenue"],
    metrics: ["net_shipping_revenue"],
    dataTypes: ["currency"],
    isImpactGraph: true,
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },
];

export const newDiscountGraphConfig: GraphConfig[] = [
  {
    title: ["% of Orders with Discount"],
    metrics: ["pct_discounted_orders"],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    canBeKeyMetric: false,
    hasTimeseries: true,
    hasProbability: false,
    hasValueCI: false,
    hasAudience: true,
    hasImpactCalculation: false,
    impactCalculationColoring: "neutral",
  },
  {
    title: ["Avg Discount"],
    metrics: [
      "avg_discount_per_discounted_order",
      "avg_discount_per_all_orders",
    ],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    hasProbability: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasTimeseries: true,
    hasAudience: true,
    hasMetricFilterIndex: true,
    hasImpactCalculation: false,
    impactCalculationColoring: "neutral",
  },
  {
    title: ["Discount % of Gross Revenue"],
    metrics: [
      "discount_pct_discounted_order_gross_revenue",
      "discount_pct_total_gross_revenue",
    ],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    showSumStackedLabels: true,
    isImpactGraph: true,
    canBeKeyMetric: false,
    hasProbability: false,
    hasValueCI: false,
    hasTimeseries: true,
    hasAudience: true,
    hasMetricFilterIndex: true,
    hasImpactCalculation: false,
    impactCalculationColoring: "neutral",
  },
  {
    title: ["Discount % of Gross Profit"],
    metrics: [
      "discount_pct_discounted_order_gross_profit",
      "discount_pct_total_gross_profit",
    ],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    canBeKeyMetric: false,
    hasProbability: false,
    hasValueCI: false,
    hasAudience: true,
    hasTimeseries: true,
    hasMetricFilterIndex: true,
    hasImpactCalculation: false,
    impactCalculationColoring: "neutral",
  },
  {
    title: ["# of Orders w/ a Discount"],
    filterMetric: "variation_id",
    metrics: ["n_orders_discounted"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    hasTimeseries: true,
    hasProbability: false,
    hasValueCI: false,
    canBeKeyMetric: false,
    hasAudience: true,
    impactCalculationColoring: "neutral",
  },
  {
    title: [""],
    metrics: ["n_visitors", "n_orders", "net_revenue"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    hasTimeseries: false,
    hasProbability: false,
    hasValueCI: false,
    canBeKeyMetric: false,
    hasAudience: false,
  },
  {
    title: ["Number Orders Discounted"],
    metrics: ["n_orders_discounted"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    hasTimeseries: false,
    hasProbability: false,
    hasValueCI: false,
    canBeKeyMetric: false,
    hasAudience: false,
  },
];

export const newSubscriptionsGraphConfig: GraphConfig[] = [
  {
    title: ["Subscription Orders per Visitor"],
    metrics: ["subscription_orders_per_visitor"],
    dataTypes: ["number"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },
  {
    title: ["Subscription Revenue per Visitor"],
    metrics: ["subscription_revenue_per_visitor"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },
  {
    title: ["Subscription Profit per Visitor"],
    metrics: ["subscription_gross_profit_per_visitor"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },
  {
    title: ["Subscription % of Orders"],
    metrics: ["pct_subscription_orders"],
    dataTypes: ["percent"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    // No stat_sig entry in analytics-v2 metrics_config.yaml, so the engine returns
    // only value + uplift for this metric — no ci_low/ci_high/p2bb/p2bc. Claiming
    // them here would render a Statistical Significance section with an empty CI bar
    // and permanently blank probability columns.
    hasProbability: false,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: false,
    hasAudience: true,
  },
  {
    title: ["Subscription AOV"],
    metrics: [
      "subscription_product_revenue_per_order",
      "subscription_shipping_revenue_per_order",
    ],
    dataTypes: ["currency"],
    stackedBarLegendTitles: ["Product AOV", "Shipping AOV"],
    datasetId: "variation_overview",
    graphType: GraphType.StackedBar,

    isImpactGraph: true,
    hasProbability: true,
    hasTimeseries: false,
    canBeKeyMetric: true,
    hasValueCI: false,
    hasAudience: false,
    impactMetric: "subscription_revenue_per_order",
    hasImpactCalculation: false,
  },
  {
    title: ["Subscription Avg Units per Order"],
    metrics: ["subscription_units_per_subscription_order"],
    dataTypes: ["number"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    showSumStackedLabels: true,
    isImpactGraph: true,
    canBeKeyMetric: true,
    hasAudience: true,
    hasTimeseries: true,
    hasProbability: true,
    hasValueCI: true,
  },
  {
    title: ["Subscription Product Revenue per Unit"],
    metrics: ["subscription_product_revenue_per_unit"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: false,
  },
  {
    title: [""],
    metrics: ["n_orders", "net_revenue"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: false,
    hasProbability: false,
    hasTimeseries: false,
    canBeKeyMetric: false,
    hasValueCI: false,
    hasAudience: false,
    hasImpactCalculation: false,
  },
  {
    title: ["Number of Subscription Orders"],
    metrics: ["n_subscription_orders"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: false,
  },
  {
    title: ["Subscription Shipping Revenue"],
    metrics: ["subscription_shipping_revenue"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: false,
  },
  {
    title: ["Number of Subscription Units"],
    metrics: ["subscription_units"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: false,
  },
  {
    title: ["Subscription Product Revenue"],
    metrics: ["subscription_product_revenue"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: false,
  },
];

export const newProductGroupsGraphConfig: GraphConfig[] = [
  {
    title: ["Product Group Mix"],
    filterMetric: "product_group",
    metrics: ["pct_total_revenue", "pct_total_units"],
    dataTypes: ["number"],
    datasetId: "variation_product_groups",
    graphType: GraphType.StackedBarHorizontal,

    maxGroupAmt: 9,
    hasMetricFilterIndex: true,
  },
  {
    title: ["Product Group Detail"],
    filterMetric: "variation_id",
    metrics: ["net_product_revenue_per_order"],
    dataTypes: ["number"],
    datasetId: "variation_product_groups",
    graphType: GraphType.Table,
  },
  {
    title: ["Product Group Detail"],
    filterMetric: "variation_id",
    metrics: ["net_product_revenue", "add_to_cart_rate", "n_orders"],
    dataTypes: ["number"],
    datasetId: "variation_products",
    graphType: GraphType.Table,
  },
  {
    title: ["Overview Data for AI"],
    metrics: [
      "conversion_rate",
      "n_orders",
      "n_visitors",
      "net_revenue",
      "net_revenue_per_visitor",
      "gross_profit_per_visitor",
      "net_product_revenue_per_order",
      "net_shipping_revenue_per_order",
      "net_revenue_per_order",
    ],
    dataTypes: ["number"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
  },
];

export const newOrdersGraphConfig: GraphConfig[] = [
  {
    title: ["Orders Over Time"],

    filterMetric: "dt",
    metrics: ["n_visitors"],
    dataTypes: ["none"],
    datasetId: "variation_overview",
    graphType: GraphType.StackedArea,

    showSumStackedLabels: true,
  },
];

export const ordersAdvancedGraphConfig: GraphConfig[] = [
  {
    title: ["% Orders by Unit Quantity"],
    filterMetric: "unit_quantity",
    metrics: ["pct_orders_by_unit_quantity"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_order_unit_mix",
    graphType: GraphType.StackedBarHorizontal,

    canBeKeyMetric: false,
    hasProbability: false,
    hasValueCI: false,
    hasAudience: false,
    hasTimeseries: false,
    maxGroupAmt: 6,
  },
  {
    title: ["% Net Revenue by Order Unit Quantity"],
    filterMetric: "unit_quantity",
    metrics: ["pct_revenue_by_unit_quantity"],
    dataTypes: ["percentNoDecimal"],
    datasetId: "variation_order_unit_mix",
    graphType: GraphType.StackedBarHorizontal,

    canBeKeyMetric: false,
    hasProbability: false,
    hasValueCI: false,
    hasAudience: false,
    hasTimeseries: false,
    maxGroupAmt: 6,
  },
  {
    title: [""],
    filterMetric: "variation_id",
    metrics: ["total_units"],
    dataTypes: ["number"],
    datasetId: "variation_histogram",
    graphType: GraphType.Histogram,

    canBeKeyMetric: false,
    hasProbability: false,
    hasValueCI: false,
    hasAudience: false,
    hasTimeseries: false,
    histogramBucket: "bin",
  },
  {
    title: ["Order Value Distribution"],
    metrics: [],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_histogram",
    graphType: GraphType.Line,

    canBeKeyMetric: false,
    hasProbability: false,
    hasValueCI: false,
    hasAudience: false,
    hasTimeseries: false,
    hasKDE: true,
    hasCDF: false,
  },
  {
    title: ["Cumulative % of Orders"],
    metrics: [],
    dataTypes: ["percent"],
    datasetId: "variation_histogram",
    graphType: GraphType.Line,

    canBeKeyMetric: false,
    hasProbability: false,
    hasValueCI: false,
    hasAudience: false,
    hasTimeseries: false,
    hasKDE: false,
    hasCDF: true,
  },
  {
    title: ["Orders Over Time"],
    metrics: ["n_orders"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.StackedArea,

    canBeKeyMetric: false,
    hasProbability: false,
    hasValueCI: false,
    hasAudience: false,
    hasTimeseries: false,
    filterMetric: "dt",
  },
  {
    title: ["Order Value Distribution"],
    metrics: [""],
    dataTypes: ["percent"],
    datasetId: "variation_histogram",
    graphType: GraphType.Line,

    canBeKeyMetric: false,
    hasProbability: false,
    hasValueCI: false,
    hasAudience: false,
    hasTimeseries: false,
    hasKDE: true,
    showLegend: true,
  },
];

export const newPersonalizationBaseGraphsConfig: GraphConfig[] = [
  {
    title: ["Orders"],
    metrics: ["n_orders"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Visitors"],
    metrics: ["n_visitors"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
  },
  {
    title: ["Conversion Rate"],
    metrics: ["conversion_rate"],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,

    hasAudience: true,
  },
  {
    title: ["Total Average Order Value"],
    metrics: ["net_revenue_per_order"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    hasAudience: true,
  },
  {
    title: ["Revenue per Visitor"],
    metrics: ["net_revenue_per_visitor"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Profit per Visitor"],
    metrics: ["gross_profit_per_visitor"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Total Revenue"],
    metrics: ["net_revenue"],
    dataTypes: ["currencyNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",

    hasAudience: true,
  },

  {
    title: ["Total Profit"],
    metrics: ["gross_profit"],
    dataTypes: ["currencyNoDecimal"],

    datasetId: "variation_overview",
    graphType: GraphType.Line,

    hasAudience: true,
  },
];

export const newPersonalizationTimeSeriesGraphsConfig: GraphConfig[] = [
  {
    title: ["Visitors"],
    metrics: ["n_visitors"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Orders"],
    metrics: ["n_orders"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Conversion Rate"],
    metrics: ["conversion_rate"],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    showGlobalMetrics: true,
    filterMetric: "dt",
  },
  {
    title: ["Total Average Order Value"],
    metrics: ["net_revenue_per_order"],
    dataTypes: ["currency"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Revenue per Visitor"],
    metrics: ["net_revenue_per_visitor"],
    dataTypes: ["currency"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Profit per Visitor"],
    metrics: ["gross_profit_per_visitor"],
    dataTypes: ["currency"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Total Revenue"],
    metrics: ["net_revenue"],
    dataTypes: ["currencyNoDecimal"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },

  {
    title: ["Total Profit"],
    metrics: ["gross_profit"],
    dataTypes: ["currencyNoDecimal"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
];

export const newPersonalizationTimeseriesOfferGraphsConfig: GraphConfig[] = [
  {
    title: ["Orders Discounted"],
    metrics: ["n_orders_discounted"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["% of Orders Discounted"],
    metrics: ["pct_discounted_orders"],
    dataTypes: ["percent"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Total Discount Offered"],
    metrics: ["total_discount"],
    dataTypes: ["currencyNoDecimal"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Discount % of Revenue (pre-discount)"],
    metrics: ["discount_pct_total_gross_revenue"],
    dataTypes: ["percent"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Discount % Profit"],
    metrics: ["discount_pct_total_gross_profit"],
    dataTypes: ["percent"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Avg Discount"],
    metrics: ["avg_discount_per_all_orders"],
    dataTypes: ["currency"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Avg Discount (discounted orders)"],
    metrics: ["avg_discount_per_discounted_order"],
    dataTypes: ["currency"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
];

export const newPersonalizationOfferGraphsConfig: GraphConfig[] = [
  {
    title: ["Orders Discounted"],
    metrics: ["n_orders_discounted"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
    hasAudience: true,
    showGlobalMetrics: true,
  },
  {
    title: ["% of Orders Discounted"],
    metrics: ["pct_discounted_orders"],
    dataTypes: ["percent"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
    hasAudience: true,
    showGlobalMetrics: true,
  },
  {
    title: ["Total Discount Offered"],
    metrics: ["total_discount"],
    dataTypes: ["currencyNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
    hasAudience: true,
    showGlobalMetrics: true,
  },
  {
    title: ["Discount % of Gross Revenue"],
    metrics: ["discount_pct_total_gross_revenue"],
    dataTypes: ["percent"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
    hasAudience: true,
    showGlobalMetrics: true,
  },
  {
    title: ["Discount % of Gross Profit"],
    metrics: ["discount_pct_total_gross_profit"],
    dataTypes: ["percent"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
    hasAudience: true,
    showGlobalMetrics: true,
  },
  {
    title: ["Avg Discount"],
    metrics: ["avg_discount_per_all_orders"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
    hasAudience: true,
    showGlobalMetrics: true,
  },
  {
    title: ["Avg Discount (discounted orders)"],
    metrics: ["avg_discount_per_discounted_order"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
    hasAudience: true,
    showGlobalMetrics: true,
  },
];

export const newPersonalizationTimeseriesUpsellGraphsConfig: GraphConfig[] = [
  {
    title: ["Orders with Checkout Upsell"],
    metrics: ["n_orders_with_checkout_upsell_product"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Checkout Upsell Revenue"],
    metrics: ["net_revenue_from_checkout_upsell"],
    dataTypes: ["currencyNoDecimal"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
];

export const newPersonalizationTimeseriesOnsiteUpsellGraphsConfig: GraphConfig[] =
  [
    {
      title: ["Onsite Upsell Views"],
      metrics: ["n_viewed_onsite_upsell"],
      dataTypes: ["numberNoDecimal"],
      datasetId: "variation_timeseries_discrete",
      graphType: GraphType.Line,
      filterMetric: "dt",
      showGlobalMetrics: true,
    },
    {
      title: ["Onsite Upsell Interactions"],
      metrics: ["n_interactions_onsite_upsell"],
      dataTypes: ["numberNoDecimal"],
      datasetId: "variation_timeseries_discrete",
      graphType: GraphType.Line,
      filterMetric: "dt",
      showGlobalMetrics: true,
    },
    {
      title: ["Onsite Upsell Add to Carts"],
      metrics: ["n_add_to_carts_onsite_upsell"],
      dataTypes: ["numberNoDecimal"],
      datasetId: "variation_timeseries_discrete",
      graphType: GraphType.Line,
      filterMetric: "dt",
      showGlobalMetrics: true,
    },
    {
      title: ["Orders with Onsite Upsell"],
      metrics: ["n_orders_with_onsite_upsell_product"],
      dataTypes: ["numberNoDecimal"],
      datasetId: "variation_timeseries_discrete",
      graphType: GraphType.Line,
      filterMetric: "dt",
      showGlobalMetrics: true,
    },
    {
      title: ["Onsite Upsell CVR"],
      metrics: ["onsite_upsell_attach_rate"],
      dataTypes: ["percentTwoDecimal"],
      datasetId: "variation_timeseries_discrete",
      graphType: GraphType.Line,
      filterMetric: "dt",
      showGlobalMetrics: true,
    },
    {
      title: ["Onsite Upsell Revenue"],
      metrics: ["net_revenue_from_onsite_upsell"],
      dataTypes: ["currencyNoDecimal"],
      datasetId: "variation_timeseries_discrete",
      graphType: GraphType.Line,
      filterMetric: "dt",
      showGlobalMetrics: true,
    },
    {
      title: ["Onsite Upsell AOV Lift"],
      metrics: ["net_revenue_from_onsite_upsell_per_order"],
      dataTypes: ["currencyNoDecimal"],
      datasetId: "variation_timeseries_discrete",
      graphType: GraphType.Line,
      filterMetric: "dt",
      showGlobalMetrics: true,
    },
  ];

export const newPersonalizationUpsellGraphsConfig: GraphConfig[] = [
  {
    title: ["Orders with Checkout Upsell"],
    metrics: ["n_orders_with_checkout_upsell_product"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Checkout Upsell Revenue"],
    metrics: ["net_revenue_from_checkout_upsell"],
    dataTypes: ["currencyNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
];

export const newPersonalizationOnsiteUpsellGraphsConfig: GraphConfig[] = [
  {
    title: ["Onsite Upsell Views"],
    metrics: ["n_viewed_onsite_upsell"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Onsite Upsell Interactions"],
    metrics: ["n_interactions_onsite_upsell"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Onsite Upsell Add to Carts"],
    metrics: ["n_add_to_carts_onsite_upsell"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Orders with Onsite Upsell"],
    metrics: ["n_orders_with_onsite_upsell_product"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Onsite Upsell CVR"],
    metrics: ["onsite_upsell_attach_rate"],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Onsite Upsell Revenue"],
    metrics: ["net_revenue_from_onsite_upsell"],
    dataTypes: ["currencyNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Onsite Upsell AOV Lift"],
    metrics: ["net_revenue_from_onsite_upsell_per_order"],
    dataTypes: ["currencyNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
];

export const newPersonalizationTimeseriesPostPurchaseGraphsConfig: GraphConfig[] =
  [
    {
      title: ["Orders with Post Purchase Upsell"],
      metrics: ["n_orders_with_post_purchase_product"],
      dataTypes: ["numberNoDecimal"],
      datasetId: "variation_timeseries_discrete",
      graphType: GraphType.Line,
      filterMetric: "dt",
      showGlobalMetrics: true,
    },
    {
      title: ["Post Purchase Upsell Revenue"],
      metrics: ["net_revenue_from_post_purchase_offer"],
      dataTypes: ["currencyNoDecimal"],
      datasetId: "variation_timeseries_discrete",
      graphType: GraphType.Line,
      filterMetric: "dt",
      showGlobalMetrics: true,
    },
  ];

export const newPersonalizationPostPurchaseGraphsConfig: GraphConfig[] = [
  {
    title: ["Orders with Post Purchase Upsell"],
    metrics: ["n_orders_with_post_purchase_product"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
  {
    title: ["Post Purchase Upsell Revenue"],
    metrics: ["net_revenue_from_post_purchase_offer"],
    dataTypes: ["currencyNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
    showGlobalMetrics: true,
  },
];

const newPostTestMetricsInTestCustomersGraphConfig: GraphConfig = {
  title: ["In-Test Customers"],
  metrics: ["n_customers"],
  dataTypes: ["numberNoDecimal"],
  datasetId: "variation_post_metrics",
  graphType: GraphType.Bar,
  hasProbability: true,
  hasTimeseries: false,
  hasValueCI: true,
  hasAudience: false,
  hasImpactCalculation: false,
  isImpactGraph: true,
};

const newPostTestMetricsCustomersRepeatOrderGraphConfig: GraphConfig = {
  title: ["% Customers with Post-Test Order"],
  metrics: ["pct_repeat_customers"],
  dataTypes: ["percentTwoDecimal"],
  datasetId: "variation_post_metrics",
  graphType: GraphType.Bar,
  hasProbability: true,
  hasTimeseries: false,
  hasValueCI: true,
  hasAudience: false,
  hasImpactCalculation: false,
  isImpactGraph: true,
};

const newPostTestMetricsOrdersPerCustomerGraphConfig: GraphConfig = {
  title: ["Post-Test Orders Per Customer"],
  metrics: ["post_orders_per_customer"],
  dataTypes: ["number"],
  datasetId: "variation_post_metrics",
  graphType: GraphType.Bar,
  hasProbability: true,
  hasTimeseries: false,
  hasValueCI: true,
  hasAudience: false,
  hasImpactCalculation: false,
  isImpactGraph: true,
  denominatorMetric: "n_customers",
};

const newPostTestMetricsRevenuePerCustomerGraphConfig: GraphConfig = {
  title: ["Post-Test Revenue Per Customer"],
  metrics: ["post_revenue_per_customer"],
  dataTypes: ["currency"],
  datasetId: "variation_post_metrics",
  graphType: GraphType.Bar,
  hasProbability: true,
  hasTimeseries: false,
  hasValueCI: true,
  hasAudience: false,
  hasImpactCalculation: false,
  isImpactGraph: true,
  denominatorMetric: "n_customers",
};

const newPostTestMetricsProfitPerCustomerGraphConfig: GraphConfig = {
  title: ["Post-Test Profit Per Customer"],
  metrics: ["post_profit_per_customer"],
  dataTypes: ["currency"],
  datasetId: "variation_post_metrics",
  graphType: GraphType.Bar,
  hasProbability: true,
  hasTimeseries: false,
  hasValueCI: true,
  hasAudience: false,
  hasImpactCalculation: false,
  isImpactGraph: true,
  denominatorMetric: "n_customers",
};

const newPostTestMetricsRevenuePerVisitorGraphConfig: GraphConfig = {
  title: ["Post-Test Revenue Per Visitor"],
  metrics: ["post_revenue_per_visitor"],
  dataTypes: ["currency"],
  datasetId: "variation_post_metrics",
  graphType: GraphType.Bar,
  hasProbability: true,
  hasTimeseries: false,
  hasValueCI: true,
  hasAudience: false,
  hasImpactCalculation: false,
  isImpactGraph: true,
};

const newPostTestMetricsProfitPerVisitorGraphConfig: GraphConfig = {
  title: ["Post-Test Profit Per Visitor"],
  metrics: ["post_profit_per_visitor"],
  dataTypes: ["currency"],
  datasetId: "variation_post_metrics",
  graphType: GraphType.Bar,
  hasProbability: true,
  hasTimeseries: false,
  hasValueCI: true,
  hasAudience: false,
  hasImpactCalculation: false,
  isImpactGraph: true,
};

export const newPostTestMetricsGraphConfig: GraphConfig[] = [
  newPostTestMetricsProfitPerVisitorGraphConfig,
  newPostTestMetricsRevenuePerVisitorGraphConfig,
  newPostTestMetricsProfitPerCustomerGraphConfig,
  newPostTestMetricsRevenuePerCustomerGraphConfig,
  newPostTestMetricsInTestCustomersGraphConfig,
  newPostTestMetricsCustomersRepeatOrderGraphConfig,
  newPostTestMetricsOrdersPerCustomerGraphConfig,
];

export const newPostTestMetricsIncludeInTestOrdersGraphConfig: GraphConfig[] = [
  {
    ...newPostTestMetricsProfitPerVisitorGraphConfig,
    title: ["Total Profit Per Visitor"],
    graphType: GraphType.StackedBar,
    metrics: ["eso_profit_per_visitor", "post_profit_per_visitor"],
    stackedBarLegendTitles: ["In-Test", "Post-Test"],
    impactMetric: "total_profit_per_visitor",
  },
  {
    ...newPostTestMetricsRevenuePerVisitorGraphConfig,
    title: ["Total Revenue Per Visitor"],
    graphType: GraphType.StackedBar,
    metrics: ["eso_revenue_per_visitor", "post_revenue_per_visitor"],
    stackedBarLegendTitles: ["In-Test", "Post-Test"],
    impactMetric: "total_revenue_per_visitor",
  },
  {
    ...newPostTestMetricsProfitPerCustomerGraphConfig,
    title: ["Total Profit Per Customer"],
    graphType: GraphType.StackedBar,
    metrics: ["eso_profit_per_customer", "post_profit_per_customer"],
    stackedBarLegendTitles: ["In-Test", "Post-Test"],
    impactMetric: "total_profit_per_customer",
  },
  {
    ...newPostTestMetricsRevenuePerCustomerGraphConfig,
    title: ["Total Revenue Per Customer"],
    graphType: GraphType.StackedBar,
    metrics: ["eso_revenue_per_customer", "post_revenue_per_customer"],
    stackedBarLegendTitles: ["In-Test", "Post-Test"],
    impactMetric: "total_revenue_per_customer",
  },
  newPostTestMetricsInTestCustomersGraphConfig,
  newPostTestMetricsCustomersRepeatOrderGraphConfig,
  {
    ...newPostTestMetricsOrdersPerCustomerGraphConfig,
    title: ["Total Orders Per Customer"],
    graphType: GraphType.StackedBar,
    metrics: ["eso_orders_per_customer", "post_orders_per_customer"],
    stackedBarLegendTitles: ["In-Test", "Post-Test"],
    impactMetric: "total_orders_per_customer",
  },
];

export const checkoutUpsellRevenueGraphConfig: GraphConfig[] = [
  {
    title: ["Checkout Upsell Revenue"],
    metrics: [
      "net_revenue_from_checkout_upsell",
      "pct_revenue_from_checkout_upsell",
      "pct_orders_with_checkout_upsell",
    ],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    isImpactGraph: true,
    canBeKeyMetric: false,
    hasProbability: false,
    hasTimeseries: false,
    hasValueCI: false,
    hasAudience: false,
    hasImpactCalculation: false,
  },
];

export const onsiteUpsellRevenueGraphConfig: GraphConfig[] = [
  {
    title: ["Onsite Upsell Revenue"],
    metrics: [
      "net_revenue_from_onsite_upsell",
      "pct_revenue_from_onsite_upsell",
      "pct_orders_with_onsite_upsell",
    ],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    isImpactGraph: true,
    canBeKeyMetric: false,
    hasProbability: false,
    hasTimeseries: false,
    hasValueCI: false,
    hasAudience: false,
    hasImpactCalculation: false,
  },
];

export const checkoutUpsellConversionGraphConfig: GraphConfig[] = [
  {
    title: ["% of Orders with Checkout Upsell"],
    metrics: [
      "pct_orders_with_checkout_upsell",
      "pct_revenue_from_checkout_upsell",
      "n_orders_with_checkout_upsell_product",
    ],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    isImpactGraph: true,
    canBeKeyMetric: false,
    hasProbability: false,
    hasTimeseries: false,
    hasValueCI: false,
    hasAudience: false,
    hasImpactCalculation: false,
  },
];

export const onsiteUpsellConversionGraphConfig: GraphConfig[] = [
  {
    title: ["% of Orders with Onsite Upsell"],
    metrics: [
      "pct_orders_with_onsite_upsell",
      "pct_revenue_from_onsite_upsell",
      "n_orders_with_onsite_upsell_product",
    ],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    isImpactGraph: true,
    canBeKeyMetric: false,
    hasProbability: false,
    hasTimeseries: false,
    hasValueCI: false,
    hasAudience: false,
    hasImpactCalculation: false,
  },
];

// Dedicated Checkout Upsell analytics page. The page imports the tile and AOV
// configs by name (no positional coupling). Several metrics here are net-new
// Tinybird fields delivered alongside this tab (checkout_upsell_attach_rate,
// checkout_upsell_revenue_per_shown, checkout_upsell_profit_per_shown,
// net_revenue_from_checkout_upsell_per_order).
const checkoutUpsellTileBase = {
  datasetId: "variation_overview",
  graphType: GraphType.Bar,
  isImpactGraph: true,
  canBeKeyMetric: false,
  hasProbability: false,
  hasTimeseries: false,
  hasValueCI: false,
  hasAudience: false,
  hasImpactCalculation: false,
  // Built-in metrics, not user custom events: use the standard bar tooltip
  // (title + value) rather than the "Visitors triggered" custom-metric one.
  isCustomMetric: false,
} as const;

// Aggregate hero tiles.
export const checkoutUpsellTileGraphConfig: GraphConfig[] = [
  {
    ...checkoutUpsellTileBase,
    title: ["Average Order Value"],
    titleTooltip:
      "Total order value divided by orders. Hover to see the breakdown by product, upsell product, and shipping.",
    // AOV broken into stacked segments so hovering reveals the breakdown.
    metrics: [
      "net_product_revenue_per_order",
      "net_shipping_revenue_per_order",
      "net_revenue_from_checkout_upsell_per_order",
      "net_revenue_per_order",
    ],
    stackedBarLegendTitles: ["Product AOV", "Shipping AOV", "Upsell AOV"],
    impactMetric: "net_revenue_per_order",
    dataTypes: ["currency"],
    graphType: GraphType.StackedBar,
  },
  {
    ...checkoutUpsellTileBase,
    title: ["Upsell Attach Rate"],
    titleTooltip: "Times accepted divided by times shown.",
    metrics: ["checkout_upsell_attach_rate"],
    dataTypes: ["percentTwoDecimal"],
  },
  {
    ...checkoutUpsellTileBase,
    title: ["Times Shown"],
    titleTooltip: "Number of sessions in which this upsell was shown",
    metrics: ["n_viewed_checkout_upsell"],
    dataTypes: ["numberNoDecimal"],
  },
  {
    ...checkoutUpsellTileBase,
    title: ["Times Accepted"],
    titleTooltip: "Number of sessions in which this upsell was purchased.",
    metrics: ["n_orders_with_checkout_upsell_product"],
    dataTypes: ["numberNoDecimal"],
  },
  {
    ...checkoutUpsellTileBase,
    title: ["Upsell Revenue"],
    titleTooltip: "Total revenue generated by this upsell.",
    metrics: ["net_revenue_from_checkout_upsell"],
    dataTypes: ["currency"],
  },
  {
    ...checkoutUpsellTileBase,
    title: ["Upsell Profit"],
    titleTooltip: "Total profit generated by this upsell.",
    metrics: ["gross_profit_from_checkout_upsell"],
    dataTypes: ["currency"],
  },
  {
    ...checkoutUpsellTileBase,
    title: ["Upsell Revenue / Visitor"],
    titleTooltip: "Upsell revenue divided by times shown.",
    metrics: ["checkout_upsell_revenue_per_shown"],
    dataTypes: ["currency"],
  },
  {
    ...checkoutUpsellTileBase,
    title: ["Upsell Profit / Visitor"],
    titleTooltip: "Upsell profit divided by times shown.",
    metrics: ["checkout_upsell_profit_per_shown"],
    dataTypes: ["currency"],
  },
];

const onsiteUpsellTileBase = checkoutUpsellTileBase;

export const onsiteUpsellTileGraphConfig: GraphConfig[] = [
  {
    ...onsiteUpsellTileBase,
    title: ["Views"],
    titleTooltip: "Unique sessions in which an onsite upsell was shown.",
    metrics: ["n_viewed_onsite_upsell"],
    dataTypes: ["numberNoDecimal"],
  },
  {
    ...onsiteUpsellTileBase,
    title: ["Interactions"],
    titleTooltip:
      "Sessions with an onsite upsell interaction (hover, modal open, click to PDP, or add to cart).",
    metrics: ["n_interactions_onsite_upsell"],
    dataTypes: ["numberNoDecimal"],
  },
  {
    ...onsiteUpsellTileBase,
    title: ["Adds to Cart"],
    titleTooltip: "Sessions that added an onsite upsell product to cart.",
    metrics: ["n_add_to_carts_onsite_upsell"],
    dataTypes: ["numberNoDecimal"],
  },
  {
    ...onsiteUpsellTileBase,
    title: ["Orders"],
    titleTooltip: "Number of orders containing an onsite upsell product.",
    metrics: ["n_orders_with_onsite_upsell_product"],
    dataTypes: ["numberNoDecimal"],
  },
  {
    ...onsiteUpsellTileBase,
    title: ["Upsell CVR"],
    titleTooltip:
      "Orders with an onsite upsell divided by views — of the visitors who saw an upsell, the share who ordered one.",
    metrics: ["onsite_upsell_attach_rate"],
    dataTypes: ["percentTwoDecimal"],
  },
  {
    ...onsiteUpsellTileBase,
    title: ["Upsell Revenue"],
    titleTooltip: "Total net revenue generated by onsite upsells.",
    metrics: ["net_revenue_from_onsite_upsell"],
    dataTypes: ["currency"],
  },
  {
    ...onsiteUpsellTileBase,
    title: ["AOV Lift"],
    titleTooltip:
      "Onsite upsell revenue per order — the portion of average order value driven by upsells.",
    metrics: ["net_revenue_from_onsite_upsell_per_order"],
    dataTypes: ["currency"],
  },
];

export const postPurchaseRevenueGraphConfig: GraphConfig[] = [
  {
    title: ["Post Purchase Upsell Revenue"],
    metrics: [
      "net_revenue_from_post_purchase_offer",
      "pct_revenue_from_post_purchase_offer",
      "pct_orders_with_post_purchase_offer",
    ],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    isImpactGraph: true,
    canBeKeyMetric: false,
    hasProbability: false,
    hasTimeseries: false,
    hasValueCI: false,
    hasAudience: false,
    hasImpactCalculation: false,
  },
];

export const postPurchaseConversionGraphConfig: GraphConfig[] = [
  {
    title: ["% of Orders with Post Purchase Upsell"],
    metrics: [
      "pct_orders_with_post_purchase_offer",
      "pct_revenue_from_post_purchase_offer",
      "net_revenue_from_post_purchase_offer",
    ],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    isImpactGraph: true,
    canBeKeyMetric: true,
    hasProbability: false,
    hasTimeseries: false,
    hasValueCI: false,
    hasAudience: false,
    hasImpactCalculation: false,
  },
];

// Product-level upsell metrics for the Products page. These inject an
// allow-listed upsell metric into the `variation_products` request so the
// shared session-order nodes compute the upstream upsell columns (the gate is a
// substring match on the metric name, e.g. "upsell" / "post_purchase_offer").
// Paired with the includeCheckoutUpsellBreakdown / includePostPurchaseOfferBreakdown
// payload flags, which project the per-product breakdown columns.
export const checkoutUpsellProductsGraphConfig: GraphConfig[] = [
  {
    title: ["Checkout Upsell Products"],
    filterMetric: "variation_id",
    metrics: ["net_revenue_from_checkout_upsell"],
    dataTypes: ["number"],
    datasetId: "variation_products",
    graphType: GraphType.Table,
  },
];

export const onsiteUpsellProductsGraphConfig: GraphConfig[] = [
  {
    title: ["Onsite Upsell Products"],
    filterMetric: "variation_id",
    metrics: ["net_revenue_from_onsite_upsell"],
    dataTypes: ["number"],
    datasetId: "variation_products",
    graphType: GraphType.Table,
  },
];

export const postPurchaseProductsGraphConfig: GraphConfig[] = [
  {
    title: ["Post Purchase Products"],
    filterMetric: "variation_id",
    metrics: ["net_revenue_from_post_purchase_offer"],
    dataTypes: ["number"],
    datasetId: "variation_products",
    graphType: GraphType.Table,
  },
];

export const AllGraphConfigs = [
  ...rolloutGraphConfig,
  ...newOverviewGraphConfig,
  ...newProfitGraphConfig,
  ...newCustomMetricsGraphConfig,
  ...newDataReconciliationGraphConfig,
  ...newShippingGraphConfig,
  ...newConversionGraphConfig,
  ...newRevenueGraphConfig,
  ...newDiscountGraphConfig,
  ...newSubscriptionsGraphConfig,
  ...newProductGroupsGraphConfig,
  ...newOrdersGraphConfig,
  ...ordersAdvancedGraphConfig,
  ...newPersonalizationBaseGraphsConfig,
  ...newPersonalizationTimeSeriesGraphsConfig,
  ...newPersonalizationTimeseriesOfferGraphsConfig,
  ...newPersonalizationOfferGraphsConfig,
  ...newPersonalizationTimeseriesUpsellGraphsConfig,
  ...newPersonalizationUpsellGraphsConfig,
  ...newPersonalizationTimeseriesOnsiteUpsellGraphsConfig,
  ...newPersonalizationOnsiteUpsellGraphsConfig,
  ...newPersonalizationTimeseriesPostPurchaseGraphsConfig,
  ...newPersonalizationPostPurchaseGraphsConfig,
  ...newPostTestMetricsGraphConfig,
];

export const AllVariationOverviewGraphConfigs = AllGraphConfigs.filter(
  (config) => config.datasetId === "variation_overview"
);

export const AllBarVariationOverviewGraphConfigs =
  AllVariationOverviewGraphConfigs.filter(
    (config) =>
      config.graphType === GraphType.Bar ||
      config.graphType === GraphType.StackedBar
  );

/**
 * 1:1 map from analytics metric ID → canonical GraphConfig.
 * Used by the analysis controller to resolve a single graph per requested metric key.
 *
 * Registration rules:
 *  - Phase 1: register each config's primary metric (metrics[0]). Last-write-wins so
 *    detail configs (newConversion, newRevenue, etc.) override rollout defaults.
 *  - Phase 2: register StackedBar impactMetrics without overriding existing entries.
 *  - Skips configs with empty titles, "Overview Data for AI", isImpactGraph === false,
 *    or canBeKeyMetric === false.
 */
function buildBarGraphConfigByMetric(): Map<string, GraphConfig> {
  const map = new Map<string, GraphConfig>();
  const impactEntries: [string, GraphConfig][] = [];

  for (const config of AllBarVariationOverviewGraphConfigs) {
    const title = config.title.join(" ").trim();
    if (!title || title === "Overview Data for AI") {
      continue;
    }
    if (config.isImpactGraph === false) {
      continue;
    }
    if (config.canBeKeyMetric === false) {
      continue;
    }

    // Phase 1: primary metric (last-write-wins)
    const primary = config.metrics[0];
    if (primary) {
      map.set(primary, config);
    }

    // Collect impactMetric entries for phase 2
    if (config.impactMetric) {
      impactEntries.push([config.impactMetric, config]);
    }
  }

  // Phase 2: register impactMetric only if not already mapped
  for (const [metric, config] of impactEntries) {
    if (!map.has(metric)) {
      map.set(metric, config);
    }
  }

  return map;
}

export const BarGraphConfigByMetric = buildBarGraphConfigByMetric();
